import { BASE_PATH as W, BaseAPI as x, operationServerMap as G } from "../base.js";
import { DUMMY_BASE_URL as u, assertParamExists as p, createRequestFunction as S, serializeDataIfNeeded as w, setSearchParams as V, toPathString as O } from "../common.js";
import L from "axios";
var g = function(a) {
  return {
    merchantWmsDataGetDashboardAnalysis: async (s, r = {}) => {
      p("merchantWmsDataGetDashboardAnalysis", "query", s);
      const n = new URL("/merchant/dc/wms/dashboard-analysis", u);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...r
      }, o = {}, l = {};
      if (s !== void 0) for (const [i, c] of Object.entries(s)) l[i] = c;
      V(n, l);
      let m = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...m,
        ...r.headers
      }, {
        url: O(n),
        options: e
      };
    },
    merchantWmsDataGetInventoryChangeProcessSummary: async (s, r = {}) => {
      p("merchantWmsDataGetInventoryChangeProcessSummary", "merchantWmsInventoryChangeProcessSummaryRequest", s);
      const n = new URL("/merchant/dc/wms/inventory-change-process-summary", u);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, o = {}, l = {};
      o["Content-Type"] = "application/json", V(n, l);
      let m = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...m,
        ...r.headers
      }, e.data = w(s, e, a), {
        url: O(n),
        options: e
      };
    },
    merchantWmsDataGetInventoryLedger: async (s, r, n, t, e, o, l, m, i, c, D, h, A, d = {}) => {
      p("merchantWmsDataGetInventoryLedger", "startDate", s), p("merchantWmsDataGetInventoryLedger", "endDate", r);
      const b = new URL("/merchant/dc/wms/inventory-ledger", u);
      let I;
      a && (I = a.baseOptions);
      const T = {
        method: "GET",
        ...I,
        ...d
      }, B = {}, v = {};
      n !== void 0 && (v.timeBasis = n), s !== void 0 && (v.startDate = s instanceof Date ? s.toISOString().substring(0, 10) : s), r !== void 0 && (v.endDate = r instanceof Date ? r.toISOString().substring(0, 10) : r), t !== void 0 && (v.categoryId = t), e !== void 0 && (v.searchKeyword = e), o && (v.inventoryTypes = o), l !== void 0 && (v.filterUnchanged = l), m !== void 0 && (v.page = m), i !== void 0 && (v.size = i), c !== void 0 && (v.sortBy = c), D !== void 0 && (v.asc = D), h !== void 0 && (v.asOfTime = h instanceof Date ? h.toISOString() : h), A !== void 0 && (v.scopeVersion = A), V(b, v);
      let M = I && I.headers ? I.headers : {};
      return T.headers = {
        ...B,
        ...M,
        ...d.headers
      }, {
        url: O(b),
        options: T
      };
    },
    merchantWmsDataGetInventoryLedgerGapMovements: async (s, r, n, t, e, o, l, m, i = {}) => {
      p("merchantWmsDataGetInventoryLedgerGapMovements", "startDate", s), p("merchantWmsDataGetInventoryLedgerGapMovements", "endDate", r), p("merchantWmsDataGetInventoryLedgerGapMovements", "asOfTime", n), p("merchantWmsDataGetInventoryLedgerGapMovements", "scopeVersion", t);
      const c = new URL("/merchant/dc/wms/inventory-ledger/gap-movements", u);
      let D;
      a && (D = a.baseOptions);
      const h = {
        method: "GET",
        ...D,
        ...i
      }, A = {}, d = {};
      s !== void 0 && (d.startDate = s instanceof Date ? s.toISOString().substring(0, 10) : s), r !== void 0 && (d.endDate = r instanceof Date ? r.toISOString().substring(0, 10) : r), n !== void 0 && (d.asOfTime = n instanceof Date ? n.toISOString() : n), t !== void 0 && (d.scopeVersion = t), e !== void 0 && (d.skuId = e), o && (d.inventoryTypes = o), l !== void 0 && (d.page = l), m !== void 0 && (d.size = m), V(c, d);
      let b = D && D.headers ? D.headers : {};
      return h.headers = {
        ...A,
        ...b,
        ...i.headers
      }, {
        url: O(c),
        options: h
      };
    },
    merchantWmsDataGetRealtimeBoardConsumptionTop: async (s, r = {}) => {
      p("merchantWmsDataGetRealtimeBoardConsumptionTop", "query", s);
      const n = new URL("/merchant/dc/wms/realtime-board/top/consumption", u);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...r
      }, o = {}, l = {};
      if (s !== void 0) for (const [i, c] of Object.entries(s)) l[i] = c;
      V(n, l);
      let m = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...m,
        ...r.headers
      }, {
        url: O(n),
        options: e
      };
    },
    merchantWmsDataGetRealtimeBoardInventoryAmountTop: async (s, r = {}) => {
      p("merchantWmsDataGetRealtimeBoardInventoryAmountTop", "query", s);
      const n = new URL("/merchant/dc/wms/realtime-board/top/inventory-amount", u);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...r
      }, o = {}, l = {};
      if (s !== void 0) for (const [i, c] of Object.entries(s)) l[i] = c;
      V(n, l);
      let m = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...m,
        ...r.headers
      }, {
        url: O(n),
        options: e
      };
    },
    merchantWmsDataGetTotalStat: async (s, r = {}) => {
      p("merchantWmsDataGetTotalStat", "query", s);
      const n = new URL("/merchant/dc/wms/stat", u);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...r
      }, o = {}, l = {};
      if (s !== void 0) for (const [i, c] of Object.entries(s)) l[i] = c;
      V(n, l);
      let m = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...m,
        ...r.headers
      }, {
        url: O(n),
        options: e
      };
    },
    merchantWmsDataGetTotalStatList: async (s, r = {}) => {
      p("merchantWmsDataGetTotalStatList", "query", s);
      const n = new URL("/merchant/dc/wms/stat/list", u);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...r
      }, o = {}, l = {};
      if (s !== void 0) for (const [i, c] of Object.entries(s)) l[i] = c;
      V(n, l);
      let m = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...m,
        ...r.headers
      }, {
        url: O(n),
        options: e
      };
    },
    merchantWmsDataGetTotalStatListByCategory: async (s, r = {}) => {
      p("merchantWmsDataGetTotalStatListByCategory", "query", s);
      const n = new URL("/merchant/dc/wms/stat/list_by_category", u);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...r
      }, o = {}, l = {};
      if (s !== void 0) for (const [i, c] of Object.entries(s)) l[i] = c;
      V(n, l);
      let m = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...m,
        ...r.headers
      }, {
        url: O(n),
        options: e
      };
    },
    merchantWmsDataGetTotalStatListV2: async (s, r = {}) => {
      p("merchantWmsDataGetTotalStatListV2", "query", s);
      const n = new URL("/merchant/dc/wms/stat/list_v2", u);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...r
      }, o = {}, l = {};
      if (s !== void 0) for (const [i, c] of Object.entries(s)) l[i] = c;
      V(n, l);
      let m = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...m,
        ...r.headers
      }, {
        url: O(n),
        options: e
      };
    },
    merchantWmsDataGetWmsStatDetailList: async (s, r = {}) => {
      p("merchantWmsDataGetWmsStatDetailList", "query", s);
      const n = new URL("/merchant/dc/wms/stat/detail", u);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...r
      }, o = {}, l = {};
      if (s !== void 0) for (const [i, c] of Object.entries(s)) l[i] = c;
      V(n, l);
      let m = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...m,
        ...r.headers
      }, {
        url: O(n),
        options: e
      };
    },
    merchantWmsDataGetWmsStatDetailListV2: async (s, r = {}) => {
      p("merchantWmsDataGetWmsStatDetailListV2", "query", s);
      const n = new URL("/merchant/dc/wms/stat/detail_v2", u);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "GET",
        ...t,
        ...r
      }, o = {}, l = {};
      if (s !== void 0) for (const [i, c] of Object.entries(s)) l[i] = c;
      V(n, l);
      let m = t && t.headers ? t.headers : {};
      return e.headers = {
        ...o,
        ...m,
        ...r.headers
      }, {
        url: O(n),
        options: e
      };
    }
  };
}, y = function(a) {
  const s = g(a);
  return {
    async merchantWmsDataGetDashboardAnalysis(r, n) {
      var t, e;
      const o = await s.merchantWmsDataGetDashboardAnalysis(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, m = (e = G["MerchantWmsDataControllerApi.merchantWmsDataGetDashboardAnalysis"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => S(o, L, W, a)(i, m || c);
    },
    async merchantWmsDataGetInventoryChangeProcessSummary(r, n) {
      var t, e;
      const o = await s.merchantWmsDataGetInventoryChangeProcessSummary(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, m = (e = G["MerchantWmsDataControllerApi.merchantWmsDataGetInventoryChangeProcessSummary"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => S(o, L, W, a)(i, m || c);
    },
    async merchantWmsDataGetInventoryLedger(r, n, t, e, o, l, m, i, c, D, h, A, d, b) {
      var I, T;
      const B = await s.merchantWmsDataGetInventoryLedger(r, n, t, e, o, l, m, i, c, D, h, A, d, b), v = (I = a == null ? void 0 : a.serverIndex) !== null && I !== void 0 ? I : 0, M = (T = G["MerchantWmsDataControllerApi.merchantWmsDataGetInventoryLedger"]) === null || T === void 0 || (T = T[v]) === null || T === void 0 ? void 0 : T.url;
      return (C, R) => S(B, L, W, a)(C, M || R);
    },
    async merchantWmsDataGetInventoryLedgerGapMovements(r, n, t, e, o, l, m, i, c) {
      var D, h;
      const A = await s.merchantWmsDataGetInventoryLedgerGapMovements(r, n, t, e, o, l, m, i, c), d = (D = a == null ? void 0 : a.serverIndex) !== null && D !== void 0 ? D : 0, b = (h = G["MerchantWmsDataControllerApi.merchantWmsDataGetInventoryLedgerGapMovements"]) === null || h === void 0 || (h = h[d]) === null || h === void 0 ? void 0 : h.url;
      return (I, T) => S(A, L, W, a)(I, b || T);
    },
    async merchantWmsDataGetRealtimeBoardConsumptionTop(r, n) {
      var t, e;
      const o = await s.merchantWmsDataGetRealtimeBoardConsumptionTop(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, m = (e = G["MerchantWmsDataControllerApi.merchantWmsDataGetRealtimeBoardConsumptionTop"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => S(o, L, W, a)(i, m || c);
    },
    async merchantWmsDataGetRealtimeBoardInventoryAmountTop(r, n) {
      var t, e;
      const o = await s.merchantWmsDataGetRealtimeBoardInventoryAmountTop(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, m = (e = G["MerchantWmsDataControllerApi.merchantWmsDataGetRealtimeBoardInventoryAmountTop"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => S(o, L, W, a)(i, m || c);
    },
    async merchantWmsDataGetTotalStat(r, n) {
      var t, e;
      const o = await s.merchantWmsDataGetTotalStat(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, m = (e = G["MerchantWmsDataControllerApi.merchantWmsDataGetTotalStat"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => S(o, L, W, a)(i, m || c);
    },
    async merchantWmsDataGetTotalStatList(r, n) {
      var t, e;
      const o = await s.merchantWmsDataGetTotalStatList(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, m = (e = G["MerchantWmsDataControllerApi.merchantWmsDataGetTotalStatList"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => S(o, L, W, a)(i, m || c);
    },
    async merchantWmsDataGetTotalStatListByCategory(r, n) {
      var t, e;
      const o = await s.merchantWmsDataGetTotalStatListByCategory(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, m = (e = G["MerchantWmsDataControllerApi.merchantWmsDataGetTotalStatListByCategory"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => S(o, L, W, a)(i, m || c);
    },
    async merchantWmsDataGetTotalStatListV2(r, n) {
      var t, e;
      const o = await s.merchantWmsDataGetTotalStatListV2(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, m = (e = G["MerchantWmsDataControllerApi.merchantWmsDataGetTotalStatListV2"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => S(o, L, W, a)(i, m || c);
    },
    async merchantWmsDataGetWmsStatDetailList(r, n) {
      var t, e;
      const o = await s.merchantWmsDataGetWmsStatDetailList(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, m = (e = G["MerchantWmsDataControllerApi.merchantWmsDataGetWmsStatDetailList"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => S(o, L, W, a)(i, m || c);
    },
    async merchantWmsDataGetWmsStatDetailListV2(r, n) {
      var t, e;
      const o = await s.merchantWmsDataGetWmsStatDetailListV2(r, n), l = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, m = (e = G["MerchantWmsDataControllerApi.merchantWmsDataGetWmsStatDetailListV2"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (i, c) => S(o, L, W, a)(i, m || c);
    }
  };
}, $ = function(a, s, r) {
  const n = y(a);
  return {
    merchantWmsDataGetDashboardAnalysis(t, e) {
      return n.merchantWmsDataGetDashboardAnalysis(t.query, e).then((o) => o(r, s));
    },
    merchantWmsDataGetInventoryChangeProcessSummary(t, e) {
      return n.merchantWmsDataGetInventoryChangeProcessSummary(t.merchantWmsInventoryChangeProcessSummaryRequest, e).then((o) => o(r, s));
    },
    merchantWmsDataGetInventoryLedger(t, e) {
      return n.merchantWmsDataGetInventoryLedger(t.startDate, t.endDate, t.timeBasis, t.categoryId, t.searchKeyword, t.inventoryTypes, t.filterUnchanged, t.page, t.size, t.sortBy, t.asc, t.asOfTime, t.scopeVersion, e).then((o) => o(r, s));
    },
    merchantWmsDataGetInventoryLedgerGapMovements(t, e) {
      return n.merchantWmsDataGetInventoryLedgerGapMovements(t.startDate, t.endDate, t.asOfTime, t.scopeVersion, t.skuId, t.inventoryTypes, t.page, t.size, e).then((o) => o(r, s));
    },
    merchantWmsDataGetRealtimeBoardConsumptionTop(t, e) {
      return n.merchantWmsDataGetRealtimeBoardConsumptionTop(t.query, e).then((o) => o(r, s));
    },
    merchantWmsDataGetRealtimeBoardInventoryAmountTop(t, e) {
      return n.merchantWmsDataGetRealtimeBoardInventoryAmountTop(t.query, e).then((o) => o(r, s));
    },
    merchantWmsDataGetTotalStat(t, e) {
      return n.merchantWmsDataGetTotalStat(t.query, e).then((o) => o(r, s));
    },
    merchantWmsDataGetTotalStatList(t, e) {
      return n.merchantWmsDataGetTotalStatList(t.query, e).then((o) => o(r, s));
    },
    merchantWmsDataGetTotalStatListByCategory(t, e) {
      return n.merchantWmsDataGetTotalStatListByCategory(t.query, e).then((o) => o(r, s));
    },
    merchantWmsDataGetTotalStatListV2(t, e) {
      return n.merchantWmsDataGetTotalStatListV2(t.query, e).then((o) => o(r, s));
    },
    merchantWmsDataGetWmsStatDetailList(t, e) {
      return n.merchantWmsDataGetWmsStatDetailList(t.query, e).then((o) => o(r, s));
    },
    merchantWmsDataGetWmsStatDetailListV2(t, e) {
      return n.merchantWmsDataGetWmsStatDetailListV2(t.query, e).then((o) => o(r, s));
    }
  };
}, j = class extends x {
  merchantWmsDataGetDashboardAnalysis(a, s) {
    return y(this.configuration).merchantWmsDataGetDashboardAnalysis(a.query, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsDataGetInventoryChangeProcessSummary(a, s) {
    return y(this.configuration).merchantWmsDataGetInventoryChangeProcessSummary(a.merchantWmsInventoryChangeProcessSummaryRequest, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsDataGetInventoryLedger(a, s) {
    return y(this.configuration).merchantWmsDataGetInventoryLedger(a.startDate, a.endDate, a.timeBasis, a.categoryId, a.searchKeyword, a.inventoryTypes, a.filterUnchanged, a.page, a.size, a.sortBy, a.asc, a.asOfTime, a.scopeVersion, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsDataGetInventoryLedgerGapMovements(a, s) {
    return y(this.configuration).merchantWmsDataGetInventoryLedgerGapMovements(a.startDate, a.endDate, a.asOfTime, a.scopeVersion, a.skuId, a.inventoryTypes, a.page, a.size, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsDataGetRealtimeBoardConsumptionTop(a, s) {
    return y(this.configuration).merchantWmsDataGetRealtimeBoardConsumptionTop(a.query, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsDataGetRealtimeBoardInventoryAmountTop(a, s) {
    return y(this.configuration).merchantWmsDataGetRealtimeBoardInventoryAmountTop(a.query, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsDataGetTotalStat(a, s) {
    return y(this.configuration).merchantWmsDataGetTotalStat(a.query, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsDataGetTotalStatList(a, s) {
    return y(this.configuration).merchantWmsDataGetTotalStatList(a.query, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsDataGetTotalStatListByCategory(a, s) {
    return y(this.configuration).merchantWmsDataGetTotalStatListByCategory(a.query, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsDataGetTotalStatListV2(a, s) {
    return y(this.configuration).merchantWmsDataGetTotalStatListV2(a.query, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsDataGetWmsStatDetailList(a, s) {
    return y(this.configuration).merchantWmsDataGetWmsStatDetailList(a.query, s).then((r) => r(this.axios, this.basePath));
  }
  merchantWmsDataGetWmsStatDetailListV2(a, s) {
    return y(this.configuration).merchantWmsDataGetWmsStatDetailListV2(a.query, s).then((r) => r(this.axios, this.basePath));
  }
}, P = {
  Shift: "SHIFT",
  NaturalDay: "NATURAL_DAY"
};
export {
  j as MerchantWmsDataControllerApi,
  g as MerchantWmsDataControllerApiAxiosParamCreator,
  $ as MerchantWmsDataControllerApiFactory,
  y as MerchantWmsDataControllerApiFp,
  P as MerchantWmsDataGetInventoryLedgerTimeBasis
};

//# sourceMappingURL=merchant-wms-data-controller-api.js.map